import { changeBoneFloors } from "./index204.js";
function undoAction({ obj, aggProps, action }) {
	return changeBoneFloors({
		obj,
		aggProps,
		...action.undo
	}).output;
}
export { undoAction };

//# sourceMappingURL=index223.js.map